<div class="overlay-container">
  <span
    class="mouse-position info-container"
    [ngClass]="textSizeClass$ | async"
  >
    {{ coordinates$ | async }}
  </span>
</div>
